import type { useHistory } from 'react-router-dom';

import { resetPageFocusAndScroll } from './resetPageFocusAndScroll';

/**
 * Goes back in the browser's history, then resets the page focus and scroll, as an in-app redirect does.
 *
 * The goBack is asynchronous (`popstate`): the reset runs once the location has changed, so that
 * the scroll restoration of the browser does not cancel it.
 *
 * @param history - history of the router.
 */
export const goBackAndResetFocus = (history: Pick<ReturnType<typeof useHistory>, 'goBack' | 'listen'>) => {
    const unlisten = history.listen(() => {
        unlisten();
        setTimeout(() => {
            resetPageFocusAndScroll();
        }, 0);
    });

    history.goBack();
};
